import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton, DangerButton} from 'Components/Button';
import {FormHandler, Input, Select} from 'Components/Form';
import {Alert} from 'Components/Partials';

import GroupsApi from 'Services/Api/Networking/Groups';
import UsersApi from 'Services/Api/Networking/Users';

import {translation} from 'Services/TranslationHelpers';

class CreateGroupModal extends React.Component {
    /**
     * @method componentDidMount
     */
    componentDidMount() {        
        if (this.props.group_id) {
            this.loadGroup();
        }
    }

    /**
     * @method loadGroup
     */
    loadGroup = async () => {
        const {group_id} = this.props;

        const response = await GroupsApi.get(group_id);

        let group = response.data;

        this.props.setForm({
            name: group.name,
            user_ids: group.user_ids,
        });
    }

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<*>}
     */
    handleSubmit = (form) => {
        const {group_id} = this.props;

        if (group_id) {
            return GroupsApi.patch(group_id, form);
        } else {
            return GroupsApi.post(null, form);
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {group_id, onClose, form, working, alert, handleInput, getFieldError, handleSubmit} = this.props;

        return (
            <Modal>
                <ModalHeader onClose={onClose}>
                    {group_id ? 'Edit' : 'Create A New'} Group
                </ModalHeader>

                <form
                    autoComplete="off"
                    onSubmit={(e) => handleSubmit(e, this.handleSubmit, onClose)}
                >
                    <ModalBody>
                        {alert !== null && (<Alert {...alert} />)}

                        <div className="grid grid-cols-1 gap-8 mb-4 text-black">
                            <Input
                                label="Name"
                                value={form.name}
                                id="name"
                                error={getFieldError('name')}
                                onChange={(v) => handleInput('name', v)}
                            />

                            <Select
                                label="Users"
                                value={form.user_ids}
                                id="user_ids"
                                onChange={(v) => handleInput('user_ids', v)}
                                isAsync
                                isMulti
                                searchCallback={(data) => UsersApi.get(null, data)}
                                searchLabelKey="name"
                            />
                        </div>
                    </ModalBody>

                    <ModalFooter alignment="center">
                        <DangerButton
                            text={translation('misc', 'cancel')}
                            onClick={onClose}
                            working={working}
                        />

                        <PrimaryButton
                            text="Save"
                            working={working}
                        />
                    </ModalFooter>
                </form>
            </Modal>
        )
    }
}

export default FormHandler(CreateGroupModal);